var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6897 0.611853C13.2899 0.230933 12.6568 0.246333 12.2759 0.646227C11.8949 1.04613 11.9104 1.67911 12.3103 2.06003L20.6455 9.99947H1C0.44772 9.99947 0 10.4472 0 10.9995C0 11.5517 0.44772 11.9995 1 11.9995H20.6456L12.3103 19.9391C11.9104 20.32 11.8949 20.9531 12.2759 21.3529C12.6568 21.7528 13.2899 21.7683 13.6897 21.3873L23.5816 11.9651C23.8068 11.7505 23.9401 11.4768 23.9815 11.1924C23.9936 11.13 24 11.0655 24 10.9995C24 10.9335 23.9936 10.8688 23.9813 10.8063C23.94 10.522 23.8067 10.2485 23.5816 10.0341L13.6897 0.611853Z",
    fill: "#5463FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueArrow);
export default __webpack_public_path__ + "static/media/blueArrow.960d8831ff94f53f1b14f89c5c084ea2.svg";
export { ForwardRef as ReactComponent };